module.exports = {"firebase":{"apiKey":"AIzaSyBCSsIGQn0mPTFyU4M5JtqZR6ovtULiK7o","authDomain":"studyeverybody2.firebaseapp.com","databaseURL":"https://studyeverybody2.firebaseio.com","projectId":"studyeverybody2","storageBucket":"studyeverybody2.appspot.com","messagingSenderId":"1025894030303","functionURL":"https://us-central1-studyeverybody2.cloudfunctions.net"},"uploadcare":{"UPLOADCARE_PUBLIC_KEY":"3e3ef11a3b587b2da4b8"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.real.json
// module id = 1087
// module chunks = 0